import script from "./ProyectosN2Listado.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProyectosN2Listado.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__